import { normalize } from "normalizr";
import { createAsyncActions } from "@ctra/utils";

import types from "./types";
import schemas from "./schemas";
import { SavedChartsResponse } from "./typings";

/**
 * Fetch saved charts
 */
const fetchSavedCharts = createAsyncActions(
  types.FETCH_SAVED_CHARTS,
  () => ({}),
  (response: SavedChartsResponse) => {
    console.log(normalize(response, schemas.savedCharts));

    return response.pages;
  },
  (error: string) => ({ error })
);

/**
 * Remove, add or reorder a tab/group
 */
const updateTabs = createAsyncActions(
  types.UPDATE_TABS,
  (pageKey, savedCharts) => ({ pageKey, savedCharts }),
  (pageKey, savedCharts) => ({ pageKey, savedCharts }),
  (error: string) => ({ error })
);

/**
 * Save a new chart to a dashboard
 */
const updateCharts = createAsyncActions(
  types.UPDATE_CHARTS,
  (pageKey, savedCharts) => ({ pageKey, savedCharts }),
  (pageKey, savedCharts) => ({ pageKey, savedCharts }),
  (error: string) => ({ error })
);

export default {
  updateCharts,
  updateTabs,
  fetchSavedCharts
};
